import { RecurringArrow } from "@/components/icons";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";

interface RecurringIconProps {
  /** The recurring invoice ID (for clickable version) */
  recurringInvoiceId?: string;
  /** Customer name to show in tooltip */
  customerName?: string;
  /** Click handler (makes the icon clickable) */
  onClick?: (id: string) => void;
  /** Tooltip text (defaults to "Recurring invoice" or "Recurring invoice: {customerName}") */
  tooltipText?: string;
  /** Size variant */
  size?: "sm" | "md";
  /** Additional class names */
  className?: string;
}

const RecurringIcon = ({
  recurringInvoiceId,
  customerName,
  onClick,
  tooltipText,
  size = "md",
  className,
}: RecurringIconProps) => {
  const sizeClasses = size === "sm" ? "h-3.5 w-3.5" : "h-4 w-4";

  const defaultTooltip = customerName
    ? `Recurring invoice: ${customerName}`
    : "Recurring invoice";

  const content = <RecurringArrow className={cn(sizeClasses, className)} />;

  const wrappedContent =
    onClick && recurringInvoiceId ? (
      <button
        onClick={(e) => {
          e.stopPropagation();
          onClick(recurringInvoiceId);
        }}
        className="inline-flex items-center justify-center text-[#1e1e24] hover:text-[#2c2c2d] transition-colors"
        aria-label={defaultTooltip}
      >
        {content}
      </button>
    ) : (
      <span className="inline-flex items-center justify-center text-[#767677]">
        {content}
      </span>
    );

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>{wrappedContent}</TooltipTrigger>
        <TooltipContent>
          <p>{tooltipText || defaultTooltip}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default RecurringIcon;
